const state = {
  search: null,
  domain: null,
  monthOffset: null
}

const mutations = {
  setSearch (state, v) {
    state.search = v
  },

  setDomain (state, { domain }) {
    state.domain = domain
  },

  clearDomain (state) {
    state.domain = null
  },

  setMonthOffset (state, { offset }) {
    state.monthOffset = offset
  }
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
